export default "__VITE_ASSET__DHthYEjq__"